import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Layout } from './components/Layout';
import { APP_URL } from './lib/site';
import Home from './pages/Home';
import Pricing from './pages/Pricing';
import Contact from './pages/Contact';
import About from './pages/About';
import Careers from './pages/Careers';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Security from './pages/Security';
import FeaturePage from './pages/features/FeaturePage';

/**
 * Redirect to a URL on another origin (the dashboard app).
 * React Router's <Navigate> only works for routes inside this app, so this
 * hands the navigation to the browser instead.
 */
function ExternalRedirect({ to }: { to: string }) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);

  return (
    <p style={{ padding: '2rem', textAlign: 'center' }}>
      Redirecting… <a href={to}>Continue</a>
    </p>
  );
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />

            {/* Feature pages; unknown and retired slugs are redirected by the page */}
            <Route path="/features/:slug" element={<FeaturePage />} />

            {/* Company Pages */}
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/about" element={<About />} />
            <Route path="/careers" element={<Careers />} />

            {/* Legal Pages */}
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/security" element={<Security />} />
          </Route>

          {/* Redirect auth routes to app subdomain */}
          <Route path="/auth/*" element={<ExternalRedirect to={`${APP_URL}/auth/login`} />} />

          {/* Redirect dashboard to app subdomain */}
          <Route path="/dashboard/*" element={<ExternalRedirect to={`${APP_URL}/dashboard`} />} />

          {/* Catch all - redirect to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;
